import { createRoot } from "react-dom/client";
import { Main } from "./main";

const container = document.querySelector("#root");
if (!container) {
  throw new Error("Root element not found");
}
const root = createRoot(container);

root.render(<Main />);
